import { render, staticRenderFns } from "./UserTitleBox.vue?vue&type=template&id=2ae5dc2b&scoped=true"
import script from "./UserTitleBox.vue?vue&type=script&lang=ts"
export * from "./UserTitleBox.vue?vue&type=script&lang=ts"
import style0 from "./UserTitleBox.vue?vue&type=style&index=0&id=2ae5dc2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae5dc2b",
  null
  
)

export default component.exports